import React, { createContext, useContext } from "react";
export interface User {
  user_id: string;
  role_id: number;
  role: 'realtor' | 'consumer' | 'guest';
  firstname: string;
  lastname: string;
  screenname: string;
  email: string;
  username: string;
  photo: string;
  ets: string;
  user_key: string;
  user_token: string;
  is_staff: boolean;
  member_number: number;
  mls_premium: string;
  connected_agent?: IConnectedAgent | null;
}

export type IUser = Partial<User> & { loading?: boolean };

export interface IConnectedAgent {
  agentkey: string;
  userid: string;
  member_number: string;
  firstname: string;
  lastname: string;
  email: string;
  rating: string;
  is_platinum: string;
  office_name: string;
  office_url: string;
  token_key: string;
  photo: string;
  connected: string;
  sent_date: string;
  connect_date: string;
  bioUrl?: string;
  brokerUrl?: string;
}

export type UserType = {
  user: IUser;
};

type UserContextType = {
  user: IUser;
  setUser: React.Dispatch<React.SetStateAction<IUser>>;
};

export const UserContext = createContext<UserContextType | undefined>(
  undefined
);

// Custom hook to use the UserContext
export const useUserContext = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error("useUserContext must be used within a UserContextProvider");
  }
  return context;
};
